import SearchBase from "@grindex-client/components/Search/search-base.class";
import { events } from "@grindex-common/helpers/events";
import { addListener } from "@grindex-common/helpers/domManipulation";

export default class SearchKeyword extends SearchBase {
	keywordExtensionName: string;
	constructor($module: HTMLElement, eventManager, dirtyManager, query) {
		super($module, eventManager, dirtyManager, query);

		this.init();
		this.keywordExtensionName = "keyword";
	}

	init() {
		this.eventManager.on(this, events.search.SETTING_BROWSER_QUERY, this.onSetBrowserQuery.bind(this));
		this.eventManager.on(this, events.search.FACET_CLEAR_ALL, this.onClearAllFacets.bind(this));

		const button = this.$module.querySelector("button[type=submit]") as HTMLElement;
		if (button) {
			addListener(button, "click", this.onKeywordSearch.bind(this));
		}

		const input = this.$module.querySelector("input[name='keyword']") as HTMLElement;
		if (input) {
			addListener(input, "keyup", this.onKeywordSearch.bind(this));
		}
	}

	onSetBrowserQuery() {
		(this.$module.querySelector("input[name='keyword']") as HTMLInputElement).value = this.queryObject.queryData.keyword;
		this.setKeywordDirtyStatus();
	}

	onClearAllFacets() {
		(this.$module.querySelector("input[name='keyword']") as HTMLInputElement).value = "";
		this.setKeywordDirtyStatus();
	}

	onKeywordSearch(e) {
		const keyword = (this.$module.querySelector("input[name='keyword']") as HTMLInputElement).value;

		e.preventDefault();

		if (e.type !== "click" && e.keyCode !== 13) {
			return false;
		}

		this.queryObject.queryData.keyword = keyword;
		this.setKeywordDirtyStatus();
		this.queryObject.resetPage();
		this.eventManager.trigger(events.search.SEARCH);

		return true;
	}

	setKeywordDirtyStatus() {
		if (this.queryObject.queryData.keyword && this.queryObject.queryData.keyword.length) {
			this.dirtyManager.setDirty(this.keywordExtensionName);
		} else {
			this.dirtyManager.removeDirty(this.keywordExtensionName);
		}
	}
}
